import { Component, OnInit } from '@angular/core';
import { Observer } from 'src/app/model/observer';
import { SurvicateService } from 'src/app/services/survicate.service';
import { NewEnvelopeService } from '../../new-envelope/new-envelope.service';
import { NewEnvelopeSteps } from 'src/app/enum/new-envelope-steps';
import { AuthService } from 'src/app/services/auth.service';
import { IToast, ToastService } from 'codex-lib';
import { TranslateService } from '@ngx-translate/core';
import { MainEnvelopeComponent } from 'src/app/main-envelope/main-envelope.component';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';

@Component({
  selector: 'app-observer-information',
  templateUrl: './observer-information.component.html',
  styleUrls: ['./observer-information.component.scss']
})

export class ObserverInformationComponent implements OnInit {
  valueSearch: string;
  isOrdered: boolean;
  settings: any;
  canSendWhatsApp: boolean = false;
  isSignFreemium: boolean = false;
  filteredObservers: Observer[] = [];
  observerInformation: any;
  blankSlateSearch: any;
  isSendWhatsapp: boolean = false;

  constructor(
    private survicateService: SurvicateService,
    private newEnvelopeService: NewEnvelopeService,
    private authService: AuthService,
    private translateService: TranslateService,
    private toastService: ToastService,
    private mainEnvelopeComponent: MainEnvelopeComponent,
    private googleAnalitycsService: AnalyticsService
  ) {
    if (!this.authService.signUserModel) {
      return;
    }
    this.canSendWhatsApp = this.authService.signUserModel.sendWhatsapp;
  }

  ngOnInit() {
    this.canSendWhatsApp = this.mainEnvelopeComponent.canSendWhatsApp;
    this.isSendWhatsapp = this.mainEnvelopeComponent.isSendWhatsapp;
    this.isSignFreemium = this.survicateService.isSignFree();
    this.observerInformation = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory);
    this.observerInformation['envelopeObserver']
      .forEach(e => {
        e.sendWhatsapp = false;
      });
    this.settings = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Settings).value;

    this.filteredObservers = this.observerInformation['envelopeObserver'];

    this.blankSlateSearch = {
      icon: {
        prefix: 'fad',
        iconName: 'search-minus'
      },
      buttonText: 'cleanSearch'
    };
  }

  onSearch(textToSearch) {
    this.valueSearch = textToSearch;
    if (textToSearch) {
      this.filteredObservers = this.observerInformation['envelopeObserver'].filter(item =>
        Object.keys(item).some(
          k =>
            item[k] != null &&
            item[k]
              .toString()
              .toLowerCase()
              .includes(textToSearch.toLowerCase())
        )
      );
    } else {
      this.filteredObservers = this.observerInformation['envelopeObserver'];
    }
  }

  onBlankSlateClearSearchClick() {
    this.onSearch('')
  };

  needSendWhatsapp(value: boolean, observerId: number) {
    this.googleAnalitycsService.sendEvent(
          new TrackerData(
            AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
            'Signer_NovEnv_Revisar_WA_Observadores',
            value ? 'Ativo' : 'Inativo'
          )
        );

    this.filteredObservers.find(x => x.id === observerId).sendWhatsApp = value;
  }

  toastWhatsFree() {
    const toast: IToast = {
      text: this.translateService.instant('contacts.acceptWhatsappSignFreeToast'),
      autoHide: true,
    };
    this.toastService.createNewToast(toast);
  }

  handleToggleClick(event: Event) {
    if (!this.canSendWhatsApp && !this.isSignFreemium) {
      event.preventDefault();
      event.stopPropagation();
      this.toastCantSendWhatsapp();
    }
  }

  toastCantSendWhatsapp() {
    const toast: IToast = {
      text: this.translateService.instant('contacts.sendMessageWhatsappDisabled'),
      autoHide: true,
    };
    this.toastService.createNewToast(toast);
  }
}
